import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';

import TabSelector from './TabSelector';

import iconSet from '../../../shared/images/teambuildr-selection.json';
import { ColorPrimary, ColorWhite } from '../../../shared/GlobalStyles';

import {
  setActiveReduxModal,
} from '../ducks/journalActions';
import { journalTracker } from '../../../shared/utils/amplitudeHelper';

const FilterContainer = styled('div')`
  align-items: center;
  display: flex;
`;

const FilterIconContainer = styled('button')`
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 42px;
  justify-content: center;
  width: 42px;
  position: relative;
`;

const FilterOptionsCount = styled('div')`
  height: 13px;
  width: 13px;
  border-radius: 50%;
  background-color: ${ColorPrimary};
  color: ${ColorWhite};
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
`;

const JournalHeaderDiv = styled('div')`
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 15px 15px 0 15px;
  position: sticky;
  top: 49px;
  z-index: 101;

  @media screen and (max-width: 640px) {
    max-width: 100%;
    min-width: 380px;
    width: 100%;
  }

  @media screen and (max-width: 576px) {
    min-width: 312px;
    padding-left: 0;
    padding-right: 0;
  }
`;

const JournalHeaderTitle = styled('div')`
  color: #222222;
  font-size: 26px;
  font-weight: 500;
`;

const UpperHeaderBox = styled('div')`
  display: flex;
  justify-content: space-between;
`;

const Header = ({ scrollToTop }) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const { mediaOnly, dateRange, filterExercise } = useSelector((state) => state.journal.data);
  const dispatch = useDispatch();

  const filterOptionsCount = useMemo(() => {
    let count = 0;
    if (mediaOnly) {
      count += 1;
    }
    if (filterExercise?.id) {
      count += 1;
    }
    if (dateRange?.startDate && dateRange?.endDate) {
      count += 1;
    }
    return count;
  }, [mediaOnly, dateRange, filterExercise]);

  const coachAccount = currentUser?.admin > 0;

  const handleFilterClick = useCallback(() => {
    dispatch(setActiveReduxModal('filter-options-modal'));
    journalTracker('Main page', 'Filter options modal opened');
  }, [dispatch]);

  return (
    <JournalHeaderDiv className='journal-header'>
      <UpperHeaderBox>
        <JournalHeaderTitle>Journal</JournalHeaderTitle>
        <FilterContainer>
          <FilterIconContainer aria-label='Open filter options' onClick={handleFilterClick}>
            <IcomoonReact iconSet={iconSet} size={26} icon='filter' color={ColorPrimary} />
            {filterOptionsCount > 0 && (
              <FilterOptionsCount>{filterOptionsCount}</FilterOptionsCount>
            )}
          </FilterIconContainer>
        </FilterContainer>
      </UpperHeaderBox>
      {coachAccount && <TabSelector scrollToTop={scrollToTop} />}
    </JournalHeaderDiv>
  );
};

Header.propTypes = {
  scrollToTop: PropTypes.func.isRequired,
};

export default Header;
